<div class="word">
  {{ wordDefinition.word }}
</div>
<div>
  {{ wordDefinition.art }}
</div>
<div class="definition" [innerHtml]="wordDefinition.definition | markdown"></div>
